import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.object({
    paymentAccountId: Yup.string().required('Required').nullable(),
    transactionTypeId: Yup.string().required('Required').nullable(),
    controlTotalAmount: Yup.string().required('Required').nullable(),
    description: Yup.string().required('Required').nullable(),
  });
